import React from 'react';
import { Card, Box, Typography } from '@mui/material';
import PieChart from './PieChart';  // Import the PieChart component
import BarChart from './BarChart';  // Import the BarChart component

const Charts = () => {
  // Static data for the Pie Chart
  const pieChartData = [
    { id: 'Customers', value: 1200 },
    { id: 'Service Providers', value: 800 },
  ];

  // Static data for the Bar Chart (example weekly bookings data)
  const barChartData = [
    { day: 'Sun', bookings: 20 },
    { day: 'Mon', bookings: 35 },
    { day: 'Tue', bookings: 25 },
    { day: 'Wed', bookings: 30 },
    { day: 'Thu', bookings: 40 },
    { day: 'Fri', bookings: 55 },
    { day: 'Sat', bookings: 60 },
  ];

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', flexWrap: 'wrap', gap: '10px',marginTop:'40px' }}>
      {/* Pie Chart Card */}
      <div style={{ width: '48%', minWidth: '400px' , maxHeight:'340px'}}>
        <Card
          sx={{
            backgroundColor: '#F5F5F5',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
            borderRadius: 2,
            height: '100%',  // Ensuring the card takes up the full height
            '&:hover': {
              backgroundColor: '#E0E0E0',
              boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.2)',
            },
            transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%' }} p={2}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', textAlign: 'center' }}>
              Active Connections
            </Typography>
            <Box sx={{ height: '250px', width: '250px' }}>
              <PieChart data={pieChartData} />
            </Box>
          </Box>
        </Card>
      </div>

      {/* Bar Chart Card */}
      <div style={{ width: '48%', minWidth: '400px' , maxHeight:'340px'}}>
        <Card
          sx={{
            backgroundColor: '#F5F5F5',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
            borderRadius: 2,
            height: '100%',  // Ensuring the card takes up the full height
            '&:hover': {
              backgroundColor: '#E0E0E0',
              boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.2)',
            },
            transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%' }} >
            <Typography variant="h6" sx={{ fontWeight: 'bold', textAlign: 'center' ,marginTop:'30px'}}>
              Weekly Booking Report
            </Typography>
            <Box sx={{ height: '250px', width: '450px' }}>
            <BarChart data={barChartData} />
            </Box>
    
          </Box>
        </Card>
      </div>
    </div>
  );
};

export default Charts;
